import { initialQueryState } from "../Historical/Store";

export interface FormSelectChoice {
  label: string;
  value: string;
  checked?: boolean;
}

export const selectedReport = [
  { label: "Commercial Banks - Structure", value: "CBS" },
  { label: "Commercial Banks - Financial", value: "CBF" },
  { label: "Savings Institutions - Structure", value: "SIS" },
  { label: "Savings Institutions - Financial", value: "SIF" },
];

export const selectedStatesAlpha = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "American Samoa", value: "AS" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "District of Columbia", value: "DC" },
  { label: "Federated States of Micronesia", value: "FM" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Guam", value: "GU" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Marshall Islands", value: "MH" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Northern Mariana Islands", value: "MP" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Palau", value: "PW" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virgin Islands", value: "VI" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

export const defaultSelectedStatesValue = ["0"];

export const selectedStates = [
  { label: "United States & Other Areas", value: "0" },
  { label: "United States (50 states and DC)", value: "99" },
  { label: "Other Areas", value: "98" },
  { label: "Alabama", value: "1" },
  { label: "Alaska", value: "2" },
  { label: "American Samoa", value: "60" },
  { label: "Arizona", value: "4" },
  { label: "Arkansas", value: "5" },
  { label: "California", value: "6" },
  { label: "Colorado", value: "8" },
  { label: "Connecticut", value: "9" },
  { label: "Delaware", value: "10" },
  { label: "District of Columbia", value: "11" },
  { label: "Federated States of Micronesia", value: "64" },
  { label: "Florida", value: "12" },
  { label: "Georgia", value: "13" },
  { label: "Guam", value: "66" },
  { label: "Hawaii", value: "15" },
  { label: "Idaho", value: "16" },
  { label: "Illinois", value: "17" },
  { label: "Indiana", value: "18" },
  { label: "Iowa", value: "19" },
  { label: "Kansas", value: "20" },
  { label: "Kentucky", value: "21" },
  { label: "Louisiana", value: "22" },
  { label: "Maine", value: "23" },
  { label: "Marshall Islands", value: "68" },
  { label: "Maryland", value: "24" },
  { label: "Massachusetts", value: "25" },
  { label: "Michigan", value: "26" },
  { label: "Minnesota", value: "27" },
  { label: "Mississippi", value: "28" },
  { label: "Missouri", value: "29" },
  { label: "Montana", value: "30" },
  { label: "Nebraska", value: "31" },
  { label: "Nevada", value: "32" },
  { label: "New Hampshire", value: "33" },
  { label: "New Jersey", value: "34" },
  { label: "New Mexico", value: "35" },
  { label: "New York", value: "36" },
  { label: "North Carolina", value: "37" },
  { label: "North Dakota", value: "38" },
  { label: "Northern Mariana Islands", value: "69" },
  { label: "Ohio", value: "39" },
  { label: "Oklahoma", value: "40" },
  { label: "Oregon", value: "41" },
  { label: "Palau", value: "70" },
  { label: "Pennsylvania", value: "42" },
  { label: "Puerto Rico", value: "72" },
  { label: "Rhode Island", value: "44" },
  { label: "South Carolina", value: "45" },
  { label: "South Dakota", value: "46" },
  { label: "Tennessee", value: "47" },
  { label: "Texas", value: "48" },
  { label: "Utah", value: "49" },
  { label: "Vermont", value: "50" },
  { label: "Virgin Islands", value: "78" },
  { label: "Virginia", value: "51" },
  { label: "Washington", value: "53" },
  { label: "West Virginia", value: "54" },
  { label: "Wisconsin", value: "55" },
  { label: "Wyoming", value: "56" },
];

export const selectedInsuranceFunds = [
  { label: "Bank Insurance Fund (BIF)", value: "BIF" },
  { label: "Resolution Trust Corporation (RTC)", value: "RTC" },
  {
    label: "Federal Savings and Loan Insurance Corporation (FSLIC)",
    value: "FSLIC",
  },
  { label: "Savings Association Insurance Fund (SAIF)", value: "SAIF" },
  { label: "Deposit Insurance Fund (DIF)", value: "DIF" },
  { label: "FDIC", value: "FDIC" },
];

export const selectedCharterTypes = [
  { value: "N", label: "National Member Banks (N)" },
  { value: "SM", label: "State Member Banks (SM)" },
  { value: "NM", label: "State Nonmember Banks (NM)" },
  { value: "SA", label: "Savings Associations (SA)" },
  { value: "SB", label: "Savings Banks and Savings and Loans (SB)" },
];

export const selectedTransactionTypes = [
  { label: "Assistance Transactions (A/A)", value: "A/A" },
  { label: "Reprivatization (REP)", value: "REP" },
  { label: "Purchase and Assumption (P&A)", value: "P&A" },
  { label: "Purchase and Assumption (PA)", value: "PA" },
  { label: "Purchase and Assumption (PI)", value: "PI" },
  { label: "Insured Deposit Transfer (IDT)", value: "IDT" },
  { label: "Cosignment Program Institution (MGR)", value: "MGR" },
  { label: "Pay Out", value: "PO" },
];

export const selectedResolutionTypes = [
  { value: "FAILURE", label: "Failure" },
  { value: "ASSISTANCE", label: "Assistance" },
];

// NOTE: attribute name under filterChoices should correspond to state.query.filters.FILTERNAME

// Note: these intermingle failures & historical fields
// This could be separated out in the future
// TODO: Separate the Historical vs. Failures to be injected from each app folder
// TODO: (for consideration) transform this into a single list of fields, and include a "type" attribute
//       - this would require changing code in ApiClient, BrowserLocation endcode/decode, etc.
export const singleValues = [
  { apiField: "CB_SI", filterName: "selectedReport" },
];
export const multiSelect = [
  { apiField: "STNUM", filterName: "selectedStates" },
  { apiField: "PSTALP", filterName: "selectedStatesAlpha" },
  { apiField: "SAVR", filterName: "selectedInsuranceFunds" },
  { apiField: "CHCLASS1", filterName: "selectedCharterTypes" },
  { apiField: "RESTYPE1", filterName: "selectedTransactionTypes" },
  { apiField: "RESTYPE", filterName: "selectedResolutionTypes" },
];
export const rangeSelect = [
  {
    apiField: "YEAR",
    filterNameStart: "selectedStartDate",
    filterNameEnd: "selectedEndDate",
  },
  {
    apiField: "FAILYR",
    filterNameStart: "startFailYear",
    filterNameEnd: "endFailYear",
  },
];

export const apiFieldMappings = {
  singleValues,
  multiSelect,
  rangeSelect,
};

export const historicalDisplayFields = [
  "TOTAL",
  "BANKS",
  "BRANCHES",
  "BRANCHIN",
  "UNIT",
  "ALLOTHER",
  "OFFICES",
  "New_Char",
  "REL_CO",
  "UNASSIST",
  "MERGERS",
  "PAID_OFF",
  "OTHER",
  "FD_SAIF",
  "FD_BIF",
  "TOT_FDIC",
  "OT_SAIF",
  "TOT_OTS",
  "TOT_SAVE",
  "CONS",
  "newcount",
  "alsonew",
  "chrtrest",
  "chartoth",
  "combos",
  "tomerg",
  "comboass",
  "tofail",
  "liqasstd",
  "tortc",
  "liqunass",
  "tochrt",
  "MISSADJ",
  "SAVINGS",
  "INTINC",
  "EINTEXP",
  "NIM",
  "NONII",
  "NONIX",
  "ELNATR",
  "ITAXR",
  "IGLSEC",
  "ITAX",
  "EXTRA",
  "NETINC",
  "COUNT",
  "PTXNOINC",
  "ILNDOM",
  "ILNFOR",
  "ILS",
  "ILNLS",
  "ISC",
  "ITRADE",
  "IFREPO",
  "ICHBAL",
  "TINTINC",
  "ILNS",
  "EDEPDOM",
  "EDEPFOR",
  "EDEP",
  "EFREPP",
  "NEW6_1",
  "ESUBND",
  "TOINTEXP",
  "OTHBORR",
  "EFHLBADV",
  "ISERCHG",
  "OONONII",
  "ESAL",
  "EPREMAGG",
  "EOTHNINT",
  "IFEE",
  "EAMINTAN",
  "DRLNLS",
  "CRLNLS",
  "NTLNLS",
  "EQCDIVP",
  "EQCDIVC",
  "EQCDIV",
  "NUMEMP",
  "NCHGREC",
  "CHBAL",
  "SC",
  "LNLSGR",
  "LNATRES",
  "LNLSNET",
  "OEA",
  "BKPREM",
  "ORE",
  "INTAN",
  "NEW9_1",
  "ASSET",
  "ORET",
  "OTHASST",
  "SCUST",
  "SCAGE",
  "SCMUNI",
  "NEW10_1",
  "SCEQ",
  "SCMV",
  "NEW10_2",
  "NEW10_3",
  "CORPBNDS",
  "SCUS",
  "SCRES",
  "TRADES",
  "SCMTGBK",
  "LNRE",
  "LNDEP",
  "LNAG",
  "LNCI",
  "LNCON",
  "LNMUNI",
  "NEW11_1",
  "LS",
  "LNLS",
  "UNINC",
  "OTLNCNTA",
  "LNRECONS",
  "LNRERES",
  "LNREMULT",
  "LNREAG",
  "LNRENRES",
  "LNREDOM",
  "LNREFOR",
  "LNRELOC",
  "LNRESRE",
  "LNCRCD",
  "LNCONOTH",
  "LNAUTO",
  "LNMOBILE",
  "LNSP",
  "LNCONOT1",
  "LNALLOTH",
  "DEP",
  "NEW14_1",
  "SUBND",
  "NEW14_2",
  "NEW14_3",
  "EQPP",
  "EQCS",
  "EQSUR",
  "NEW14_4",
  "EQOTHCC",
  "EQNM",
  "OTHNBORR",
  "SUBLLPF",
  "OTHLIAB",
  "LIAB",
  "EQUPTOT",
  "EQNWCERT",
  "LIABEQ",
  "NEW15_1",
  "NEW15_2",
  "NEW15_3",
  "NEW15_4",
  "DEPI",
  "DEPNI",
  "DDT",
  "NEW15_5",
  "NTRTIME",
  "NEW15_7",
  "TRN",
  "NTR",
  "NTRTMLG",
  "IRAKEOGH",
  "BRO",
  "CHBALI",
  "FREPO",
  "INTBAST",
  "FREPP",
  "MTGLS",
  "NEW16_1",
  "INTBLIB",
  "TRADE",
  "OTHBFHLB",
  "OINTBOR",
  "DEPNIFOR",
  "DEPIFOR",
  "DEPFOR",
  "P3LNLS",
  "P9LNLS",
  "TPD",
  "NALNLS",
  "NCLNLS",
  "STNAME",
];

export const failuresDiplayFields = [
  "NAME",
  "CERT",
  "FIN",
  "CITYST",
  "FAILDATE",
  "SAVR",
  "RESTYPE",
  "COST",
  "RESTYPE1",
  "CHCLASS1",
  "QBFDEP",
  "QBFASSET",
];
export const initialStateCleared = {
  filters: {
    selectedReport: "",
    selectedStates: ["0"],
    previousLocations: ["0"],
    selectedStartDate: "",
    selectedEndDate: "",
  },
  sort: {
    sortField: "YEAR",
    sortOrder: "desc",
  },
  fixedDisplayFields: ["YEAR"],
  displayFields: ["STNAME"],
  urls: {
    apiJson: null,
    csvDownload: null,
    browserPath: "",
  },
};

export const initialCBSState = {
  filters: {
    selectedReport: "CBS",
    selectedStates: defaultSelectedStatesValue,
    previousLocations: defaultSelectedStatesValue,
    selectedStartDate: "1934",
    selectedEndDate: initialQueryState.filters.selectedEndDate,
  },
  sort: {
    sortField: "YEAR",
    sortOrder: "desc",
  },
  fixedDisplayFields: ["YEAR"],
  displayFields: ["STNAME", "TOTAL", "BRANCHES", "New_Char"],
  urls: {
    apiJson: null,
    csvDownload: null,
    browserPath: "",
  },
};

export const initialCBFState = {
  filters: {
    selectedReport: "CBS",
    selectedStates: defaultSelectedStatesValue,
    previousLocations: defaultSelectedStatesValue,
    selectedStartDate: "1934",
    selectedEndDate: initialQueryState.filters.selectedEndDate,
  },
  sort: {
    sortField: "YEAR",
    sortOrder: "desc",
  },
  fixedDisplayFields: ["YEAR"],
  displayFields: ["STNAME", "BANKS", "ASSET", "DEP", "EQNM", "NETINC"],
  urls: {
    apiJson: null,
    csvDownload: null,
    browserPath: "",
  },
};

export const initialSISState = {
  filters: {
    selectedReport: "SIS",
    selectedStates: defaultSelectedStatesValue,
    previousLocations: defaultSelectedStatesValue,
    selectedStartDate: "1934",
    selectedEndDate: initialQueryState.filters.selectedEndDate,
  },
  sort: {
    sortField: "YEAR",
    sortOrder: "desc",
  },
  fixedDisplayFields: ["YEAR"],
  displayFields: ["STNAME", "SAVINGS", "newcount", "chartoth", "tochrt"],
  urls: {
    apiJson: null,
    csvDownload: null,
    browserPath: "",
  },
};

export const initialSIFState = {
  filters: {
    selectedReport: "SIF",
    selectedStates: defaultSelectedStatesValue,
    previousLocations: defaultSelectedStatesValue,
    selectedStartDate: "1934",
    selectedEndDate: initialQueryState.filters.selectedEndDate,
  },
  sort: {
    sortField: "YEAR",
    sortOrder: "desc",
  },
  fixedDisplayFields: ["YEAR"],
  displayFields: ["STNAME", "COUNT", "ASSET", "DEP", "EQNM", "NETINC"],
  urls: {
    apiJson: null,
    csvDownload: null,
    browserPath: "",
  },
};
